/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://discussion-tool-demo-api.geodemosolutions.com/public/'
  // appBaseUrl = 'https://discussion-tool-demo.geodemosolutions.com/#/'
  baseApiUrl = 'https://nel-fpw-discussion-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://nel-fpw-discussion-tool-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/nel-fpw-discussion-tool-api/public/'
  appBaseUrl = 'http://localhost:4000/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
